import React from 'react'
import PropTypes from 'prop-types'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import InputBase from '@material-ui/core/InputBase'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import Hidden from '@material-ui/core/Hidden'
import MenuIcon from '@material-ui/icons/Menu'
import SearchIcon from '@material-ui/icons/Search'
import AccountCircle from '@material-ui/icons/AccountCircle'
import { withStyles } from '@material-ui/core/styles'

const styles = (theme) => ({
  appBar: {
    backgroundColor: 'transparent',
    color: theme.palette.text.primary,
    boxShadow: 'none',
    position: 'static',
  },
  toolbar: {
    minHeight: 72,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    [theme.breakpoints.up('md')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
  titleBlock: {
    flex: 1,
    minWidth: 0,
  },
  title: {
    fontWeight: 700,
    fontSize: '1.25rem',
    lineHeight: 1.3,
  },
  subtitle: {
    color: theme.palette.text.secondary,
    fontSize: '0.85rem',
  },
  search: {
    display: 'none',
    alignItems: 'center',
    backgroundColor: '#ffffff',
    border: '1px solid #e5e7eb',
    borderRadius: 999,
    padding: '6px 14px',
    marginRight: theme.spacing(1.5),
    minWidth: 220,
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
    },
  },
  searchIcon: {
    color: theme.palette.text.secondary,
    marginRight: 8,
  },
  searchInput: {
    flex: 1,
    fontSize: '0.9rem',
  },
  user: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    borderRadius: 999,
    padding: '4px 8px 4px 4px',
    backgroundColor: '#ffffff',
    border: '1px solid #e5e7eb',
  },
  userName: {
    fontSize: '0.9rem',
    fontWeight: 600,
    marginRight: 4,
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
})

class TopBar extends React.Component {
  state = {
    anchorEl: null,
  }

  handleMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget })
  }

  handleClose = () => {
    this.setState({ anchorEl: null })
  }

  render() {
    const {
      classes,
      title,
      subtitle,
      onMenuClick,
      searchValue,
      onSearchChange,
      searchPlaceholder = '搜尋...',
      showSearch = false,
      actions,
    } = this.props
    const open = Boolean(this.state.anchorEl)

    return (
      <AppBar className={classes.appBar} position="static" color="default" elevation={0}>
        <Toolbar className={classes.toolbar}>
          <Hidden mdUp>
            <IconButton edge="start" onClick={onMenuClick} aria-label="open drawer">
              <MenuIcon />
            </IconButton>
          </Hidden>
          <div className={classes.titleBlock}>
            <Typography className={classes.title} noWrap>
              {title}
            </Typography>
            {subtitle ? (
              <Typography className={classes.subtitle} noWrap>
                {subtitle}
              </Typography>
            ) : null}
          </div>
          {showSearch ? (
            <div className={classes.search}>
              <SearchIcon className={classes.searchIcon} fontSize="small" />
              <InputBase
                className={classes.searchInput}
                placeholder={searchPlaceholder}
                value={searchValue || ''}
                onChange={onSearchChange}
              />
            </div>
          ) : null}
          {actions}
          <div className={classes.user}>
            <IconButton
              aria-owns={open ? 'menu-appbar' : undefined}
              aria-haspopup="true"
              onClick={this.handleMenu}
              color="inherit"
              size="small"
            >
              <AccountCircle />
            </IconButton>
            <Typography className={classes.userName}>Admin</Typography>
            <Menu
              id="menu-appbar"
              anchorEl={this.state.anchorEl}
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              open={open}
              onClose={this.handleClose}
            >
              <a href="/logout" style={{ textDecoration: 'none', color: 'inherit' }}>
                <MenuItem onClick={this.handleClose}>登出</MenuItem>
              </a>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
    )
  }
}

TopBar.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  onMenuClick: PropTypes.func,
  searchValue: PropTypes.string,
  onSearchChange: PropTypes.func,
  searchPlaceholder: PropTypes.string,
  showSearch: PropTypes.bool,
  actions: PropTypes.node,
}

export default withStyles(styles)(TopBar)
